<template>
  <section
    id="cover"
    class="te-bg-webmarketing-image relative flex h-[500px] flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faChartLineUp"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      Webマーケティングコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      効果的な広告プランニングと運用を行い、Webサイトを成長させよう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        Webマーケティングを勉強・学習して短期間でWeb
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >広告のプランニングと運用ができるようになる講座。スクールでは、効果的なWeb広告出稿を行い、Webサイトを成長させられるようになることがゴールです。1人では続かない方のためのパーソナルメンターがつくブートキャンプ。第一線で活躍する現役Webマーケターがあなたを全力でサポートします。専属のパーソナルメンターがマンツーマンでサポート。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!--バッジ -->
    <div class="te-badge-ga4">
      <div class="relative flex justify-center md:flex-col">
        <span class="te-ga4-logo" />
        <span class="te-ga4-version leading-none">最新バージョン</span>
        <span
          class="co-display-11 te-ga4-color mt-3 font-bold md:mt-0"
          style="line-height: 1;"
        >
          GA4対応!
        </span>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChartLineUp } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faChartLineUp,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-webmarketing-image {
  background-image: linear-gradient(
      to top,
      rgba(28, 120, 126, 0.75),
      rgba(48, 199, 208, 0.75)
    ),
    url('~/assets/images/Te/TeCourse/Webmarketing/Cover/webmarketing.jpg');
}

.te-badge-ga4 {
  position: relative;
  width: 21.4375rem;
  height: 2.5rem;
  margin-top: 1.125rem;
  background-color: #efefef;
  @media (min-width: 576px) {
    margin-top: 1.75rem;
  }
  @media (min-width: 768px) {
    position: absolute;
    right: 1.25rem;
    bottom: 1.25rem;
    width: 7.8125rem;
    height: 7.8125rem;
    border-radius: 50%;
  }
  .te-ga4-logo {
    width: 7.5rem;
    height: 1.5rem;
    margin-top: 0.5rem;
    background: url('~/assets/images/Te/TeCourse/Webmarketing/Cover/ga4-logo-sp.png')
      no-repeat center top / 7.5rem 1.5rem;
    @media (min-width: 768px) {
      width: 7.8125rem;
      height: 3.25rem;
      margin-top: 0.875rem;
      background: url('~/assets/images/Te/TeCourse/Webmarketing/Cover/ga4-logo.png')
        no-repeat center top / 4.625rem 3.25rem;
    }
  }
  .te-ga4-version {
    width: 4.875rem;
    height: 0.875rem;
    padding: 0.125rem 0.25rem;
    margin: 0.8125rem 0.125rem 0.8125rem 0.3125rem;
    font-size: 0.625rem;
    background-color: #f57e02;
    @media (min-width: 768px) {
      margin: 0.3125rem auto 0.125rem;
    }
  }
  .te-ga4-color {
    color: #f57e02;
  }
}
</style>
